import { mutator } from 'satcheljs';
import { updateAgendaMailDisabledForFolder } from 'owa-agenda-mail-option/lib/actions/internalActions';

export const udpateAgendaMailDisabledForFolderMutator = mutator(
    updateAgendaMailDisabledForFolder,
    actionMessage => {
        const { folder, newAgendaDisabledValue } = actionMessage;
        folder.AgendaMailDisabled = newAgendaDisabledValue;
    }
);
